import { render } from "./ImageInfo.vue?vue&type=template&id=5da78a04"
import script from "./ImageInfo.vue?vue&type=script&lang=js"
export * from "./ImageInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__